export default __webpack_public_path__ + "static/media/searchIcon.23a93868.svg";